import { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Typography from '@mui/material/Typography';

const ProcessStatus = ({ lst, process }) => {
    const [status, setStatus] = useState('');
    const [count, setCount] = useState(0);

    useEffect(() => {
        let isFinalized = true;
        let tempCount = 0;
        lst.forEach((item) => {
            if (item.Status === 'Pending' || item.Status !== 'Finalized') {
                isFinalized = false;
                tempCount++;
            }
        });
        setStatus(isFinalized ? "Finalized" : "Needs Review");
        setCount(tempCount);
    }, [lst]);

    return (
        <Box sx={{display: 'flex',
        }}>
            <FiberManualRecordIcon sx={{ 
                color: status === 'Needs Review' ? 'red' : (status === 'Finalized' ? 'green' : 'error'), 
                fontSize: '1.5rem',
            }} />
            <Typography>
                {process} {" "}
                {status === 'Needs Review' && `(${count}) needing review`}
                {status === 'Finalized' ? "Finalized" : status !== 'Needs Review' ? "Error" : null}
            </Typography>
        </Box>
    );
};

export default ProcessStatus;